import { useState } from 'react';

import { PaginationQuery } from '~services/pagination';

type DataGridSearchFilterValue = PaginationQuery[string];
type DataGridSearchFilters = Record<string, DataGridSearchFilterValue>;

// legacy interface
interface AddSearchHeaderParamsProps {
  params: PaginationQuery;
  searchValue: string | undefined;
  filterParams?: DataGridSearchFilters;
}

// interface when using codegen services
interface AddSearchHeaderQueryProps {
  query: PaginationQuery;
  searchValue: string | undefined;
  filterQuery?: DataGridSearchFilters;
}

export const useDataGridSearch = () => {
  const [searchValue, setSearchValue] = useState('');

  // legacy method
  const addSearchHeaderParam = ({
    params,
    searchValue,
    filterParams,
  }: AddSearchHeaderParamsProps) => {
    if (searchValue?.length) {
      params = { 'search[datagrid]': searchValue || '', ...params };
    }

    // Handle filter params
    if (filterParams) {
      const filters: DataGridSearchFilters = {};

      Object.keys(filterParams).forEach((key) => {
        filters[`filter[${key}]`] = filterParams[key];
      });

      params = { ...params, ...filters };
    }

    return params;
  };

  // use with codegen services
  const addSearchHeaderQuery = ({
    query,
    searchValue,
    filterQuery,
  }: AddSearchHeaderQueryProps) => {
    if (searchValue?.length) {
      query = { 'search[datagrid]': searchValue || '', ...query };
    }

    // Handle filter query
    if (filterQuery) {
      const filters: DataGridSearchFilters = {};

      Object.keys(filterQuery).forEach((key) => {
        filters[`filter[${key}]`] = filterQuery[key];
      });

      query = { ...query, ...filters };
    }

    return query;
  };

  const setSearchQueryValue = (searchValue?: string) => {
    setSearchValue(searchValue || '');
  };

  return { addSearchHeaderParam, addSearchHeaderQuery, searchValue, setSearchQueryValue };
};
